import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'gb-item-form-field',
  templateUrl: './gb-item-form-field.component.html',
  styleUrls: ['./gb-item-form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbItemFormFieldComponent {
  @Input() shouldShowField: boolean = true
  @Input({ required: true }) bulkUpdate!: boolean
  @Input({ required: true }) fieldName!: string
  @Input() disableLimitHeight = false
  @Input() hideRemoveButton = false
  @Output() removeField = new EventEmitter<string>()
}
